import { styled } from "@mui/system";
import TextView from "../../../TextView";
import { ASSETS } from "../../../../utils/config";
import { colors } from "../../../../utils";
import { getStatusValue } from "../../../../utils/helpers";
import Tooltip from "@mui/material/Tooltip";
import IyugaTooltip from "../../../IyugaTooltip";
import CopiedFromCloneIcon from "../../../Icons/CopiedFromCloneIcon";

// Visibility constants
const PUBLIC_VISIBILITY = 1;
const PRIVATE_VISIBILITY = 2;
const HIDDEN_VISIBILITY = 3;

const Container = styled("div")({
  height: "4vh",
  width: "100%",
  marginTop: "10px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

const StatusBox = styled("div")(({ theme, visibility }) => ({
  height: "100%",
  alignItems: "center",
  padding: "2px 10px",
  backgroundColor:
    visibility === HIDDEN_VISIBILITY
      ? "#EFE9FE"
      : visibility === PUBLIC_VISIBILITY
      ? colors.LightGreenBackground
      : colors.TimedWheel,
  borderRadius: "20px",
  display: "flex",
  justifyContent: "space-around",
}));

const IconGroup = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  padding: "3px 0px",
  width: "36%",
  gap: "6px",
});

const StatusText = styled(TextView)(({ theme, visibility }) => ({
  fontSize: "12px",
  lineHeight: "18px",
  paddingLeft: "5px",
  color:
    visibility === HIDDEN_VISIBILITY
      ? "#9B5AF8"
      : visibility === PUBLIC_VISIBILITY
      ? colors.PrimaryGreen
      : colors.StrokePrimary,
}));

const WheelStatus = ({ data, isOthersGallery }) => {
  const visibility = data?.visibility || PRIVATE_VISIBILITY;

  return (
    <Container>
      <StatusBox visibility={visibility}>
        <img
          src={
            visibility === HIDDEN_VISIBILITY
              ? ASSETS.segmentEditor.Incognito
              : visibility === PUBLIC_VISIBILITY
              ? ASSETS.segmentEditor.PublicWheel
              : ASSETS.segmentEditor.PrivateWheel
          }
          width={20}
          height={20}
          alt="Status Icon"
        />
        <StatusText variant="tag" visibility={visibility}>
          {getStatusValue(visibility)}
        </StatusText>
      </StatusBox>
      <IconGroup>
        {data?.version === 1 && (
          <Tooltip title="Legacy Wheel - No Longer Supported" arrow>
            <img
              src={ASSETS.segmentEditor.OldWheels}
              width={18}
              height={18}
              alt="Locked Icon"
            />
          </Tooltip>
        )}
        {data?.is_locked && (
          <IyugaTooltip tooltip={<TextView>Locked</TextView>}>
            <img
              src={ASSETS.segmentEditor.LockWheel}
              width={18}
              height={18}
              alt="Locked Icon"
            />
          </IyugaTooltip>
        )}
        {data?.is_cloned && (
          <IyugaTooltip tooltip={<TextView>Cloned</TextView>}>
            <img
              src={ASSETS.segmentEditor.CloneWheel}
              width={18}
              height={18}
              alt="Cloned Icon"
            />
          </IyugaTooltip>
        )}
        {data?.is_copied_from_clone && (
          <IyugaTooltip tooltip={<TextView>Edited from Clone</TextView>}>
            <CopiedFromCloneIcon width={20} height={18} />
          </IyugaTooltip>
        )}
        {!data?.is_clonable && isOthersGallery && (
          <IyugaTooltip
            tooltip={<TextView>This Wheel Cannot be cloned</TextView>}
          >
            <img
              src={ASSETS.CloningDisabled}
              width={18}
              height={18}
              alt="CloningDisabled Icon"
            />
          </IyugaTooltip>
        )}
        {/* {data?.is_live && (
          <IyugaTooltip
            tooltip={
              <TextView>
                {data?.is_cloned 
                  ? (data?.changes_update
                      ? "Clone has been Updated since your last visit!"
                      : "Clone Up-To-Date")
                  : "Generates Sync Clones - will update automatically when the Original Author synchronize changes."}
              </TextView>
            }
          >
            <img
              src={
                data?.changes_update
                  ? ASSETS.BroadCastUpdateYellowIcon
                  : ASSETS.BroadCastIcon
              }
              width={18}
              height={18}
              alt="Live Share Icon"
            />
          </IyugaTooltip>
        )} */}
        {/* if user has cloned someone else's wheel */}
        {data?.is_live && data?.is_cloned && (
          <IyugaTooltip
            tooltip={
              <TextView>
                {data?.is_cloned
                  ? !data?.changes_update
                    ? "Clone has been Updated since your last visit!"
                    : "Clone Up-To-Date"
                  : "Generates Sync Clones - will update automatically when the Original Author synchronize changes."}
              </TextView>
            }
          >
            <img
              src={data?.changes_update ? ASSETS.Sync2 : ASSETS.SyncWarning}
              width={18}
              height={18}
              alt="Live Share Icon"
            />
          </IyugaTooltip>
        )}
        {data?.is_live && !data?.is_cloned && (
          <IyugaTooltip
            tooltip={
              <TextView>
                Generates Sync Clones - will update automatically when the
                Original Author synchronize changes.
              </TextView>
            }
          >
            <img
              src={ASSETS.Sync2}
              width={18}
              height={18}
              alt="Live Share Icon"
            />
          </IyugaTooltip>
        )}
        {data?.live_to_static && data?.is_cloned && (
          <IyugaTooltip
            tooltip={
              <TextView>
                Clone has been disconnected and is no longer live.
              </TextView>
            }
          >
            <img
              src={ASSETS.SyncError}
              width={18}
              height={18}
              alt="Live Share Icon"
            />
          </IyugaTooltip>
        )}
      </IconGroup>
    </Container>
  );
};

export default WheelStatus;
